import React from 'react';
import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import PeriodsPanel from './PeriodsPanel';
import UsersPanel from './UsersPanel';
import SemestersPanel from './SemestersPanel';
import DistrictPanel from './DistrictPanel';
import TestHarnessPanel from './TestHarnessPanel';
import useHarnessEnabled from '../../hooks/useHarnessEnabled';
import useAuth from '../../hooks/useAuth';
import { isAdminOrAbove } from '../../utils/roles';

const AdminNav = ({ tabs }) => (
  <nav className="flex gap-2 flex-wrap mb-6">
    {tabs.map(({ to, label }) => (
      <NavLink
        key={to}
        to={to}
        className={({ isActive }) =>
          `rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
            isActive
              ? 'bg-indigo-600 text-white'
              : 'border border-gray-300 text-gray-700 hover:bg-gray-50'
          }`
        }
      >
        {label}
      </NavLink>
    ))}
  </nav>
);

export default function AdminPage() {
  const harnessEnabled = useHarnessEnabled();
  const { user } = useAuth();
  const isAdmin = isAdminOrAbove(user);

  // SSLs can manage Periods (backend: IsSSLOrAbove). Users / Semesters /
  // District Setup are admin-only on the backend, so they're hidden from SSLs.
  const tabs = [];
  if (isAdmin) tabs.push({ to: '/admin/users', label: 'Users' });
  if (isAdmin) tabs.push({ to: '/admin/semesters', label: 'Semesters' });
  tabs.push({ to: '/admin/periods', label: 'Periods' });
  if (isAdmin) tabs.push({ to: '/admin/district', label: 'District Setup' });
  if (harnessEnabled) tabs.push({ to: '/admin/harness', label: 'Test Harness' });

  const defaultPanel = isAdmin ? <UsersPanel /> : <Navigate to="/admin/periods" replace />;

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-4">
        {isAdmin ? 'Admin' : 'Scheduling'}
      </h1>
      <AdminNav tabs={tabs} />
      <Routes>
        {isAdmin && <Route path="users"     element={<UsersPanel />} />}
        {isAdmin && <Route path="semesters" element={<SemestersPanel />} />}
        <Route path="periods"   element={<PeriodsPanel />} />
        {isAdmin && <Route path="district"  element={<DistrictPanel />} />}
        {harnessEnabled && <Route path="harness" element={<TestHarnessPanel />} />}
        <Route index            element={defaultPanel} />
      </Routes>
    </div>
  );
}
